<div *ngIf="parentOrgName" class="card-sm shadow-sm rounded-4 border-0 mb-2 parent-org-card">
  <div class="card-body py-3 px-4">
    <h6 class="mb-0 text-primary parent-org-title">
      Parent Organization: {{ parentOrgName }}
    </h6>
  </div>
</div>

<div class="add-sub-org-container">
    <div class="row no-gutters" style="flex-wrap:nowrap; overflow-x:hidden;">
        <div class="col-lg-8" style="flex: 0 0 60%; max-width: 60%;">
            <div class="card shadow-sm rounded-4 border-0 h-100">
                <div class="card-body p-4">
                    <div *ngIf="saveSuccess" class="alert alert-success col-md-7" role="alert">
                        Sub Organization is created successfully!
                    </div>
                    <div *ngIf="serverError" class="alert alert-danger col-md-7" role="alert">
                        A server error occurred. Please try again later.
                    </div>

                    <form [formGroup]="subOrgForm" (ngSubmit)="save()" class="sub-org-form">
                        <!-- Sub Org Name -->
                        <div class="mb-4 mt-3 p-4 rounded bg-light-subtle">
                            <label for="name" class="form-label fw-semibold">Sub Organization Name <span class="text-danger">*</span></label>
                            <input id="name"
                                   class="form-control"
                                   [ngClass]="{'is-invalid': subOrgForm.get('name')?.invalid && subOrgForm.get('name')?.touched}"
                                   formControlName="name"
                                   placeholder="Sub Organization Name"
                                   required
                                   (blur)="subOrgForm.get('name')?.markAsTouched()" />
                            <div class="text-danger mt-1" *ngIf="subOrgForm.get('name')?.invalid && subOrgForm.get('name')?.touched">
                                Sub Organization Name is required.
                            </div>
                        </div>
                        <!-- Address Section (Single Column) -->
                        <div class="mb-4 rounded bg-light-subtle address-section" style="padding: 1rem;">
                            <h6 class="mb-3 sub-section-heading">
                                Address
                            </h6>
                            <div class="row g-3">
                                <div class="col-12 mb-3">
                                    <label for="address1" class="form-label">Address 1</label>
                                    <input id="address1" class="form-control" formControlName="address1"
                                        placeholder="Address line 1" />
                                </div>
                                <div class="col-12 mb-3">
                                    <label for="address2" class="form-label">Address 2</label>
                                    <input id="address2" class="form-control" formControlName="address2"
                                        placeholder="Address line 2" />
                                </div>
                                <div class="col-12 mb-3">
                                    <label for="city" class="form-label">City</label>
                                    <input id="city" class="form-control" formControlName="city" placeholder="City" />
                                </div>
                                <div class="col-12 mb-3">
                                    <label for="state" class="form-label">State</label>
                                    <input id="state" class="form-control" formControlName="state" placeholder="State" />
                                </div>
                                <div class="col-12 mb-3">
                                    <label for="postalCode" class="form-label">Postal Code</label>
                                    <input id="postalCode" class="form-control" formControlName="postalCode"
                                        placeholder="Postal Code" />
                                </div>
                                <div class="col-12 mb-3">
                                    <label for="country" class="form-label">Country</label>
                                    <input id="country" class="form-control" formControlName="country" placeholder="Country" />
                                </div>
                                <div class="col-12 mb-3">
                                    <label for="phone" class="form-label">Phone</label>
                                    <input id="phone" class="form-control" formControlName="phone" placeholder="Phone" />
                                </div>
                            </div>
                        </div>

                        <!-- Point of Contact Section -->
                        <div class="mb-4 p-4 rounded bg-light-subtle contact-section">
                            <h6 class="mb-3 sub-section-heading">
                                Point of Contact
                            </h6>
                            <div class="row g-4">
                                <div class="col-md-6 mb-3">
                                    <label for="firstName" class="form-label">First Name</label>
                                    <input id="firstName" class="form-control" formControlName="firstName"
                                        placeholder="First Name" />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="lastName" class="form-label">Last Name</label>
                                    <input id="lastName" class="form-control" formControlName="lastName"
                                        placeholder="Last Name" />
                                </div>
                            </div>
                        </div>

                       <div class="mb-4 p-4 rounded bg-light-subtle">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="active" formControlName="active" style="transform: scale(1.1); margin-right: 6px;" />
                                <label class="form-check-label fs-6" for="active">Active</label>
                            </div>
                        </div>

                        <div class="d-flex gap-2 mt-3">
                          <button type="submit" class="btn btn-gradient flex-fill py-3" [disabled]="!isFormChanged()">Save</button>
                          <button type="button" class="btn btn-outline-secondary flex-fill py-3" (click)="cancel()" [disabled]="!isFormChanged()">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-lg-4 mt-4 mt-lg-0 d-flex align-items-start justify-content-end" 
             style="flex: 0 0 38%; max-width: 38%; padding-left: 1rem;">
            <div style="width:400px;max-width:100%;">
                <app-organization-details [orgId]="parentOrgId"></app-organization-details>
            </div>
        </div>
    </div>
</div>